import { BasePage as CngBasePage } from 'cng-web-lib'
import React from 'react'
import TablePage from '../../xbsng/SubmStatusSearchTablePage.js'
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap'


function WrappedTablePage(props) {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return (
    <CngBasePage
      renderPage={(showSnackbar) => (
        <TablePage 
          showNotification={showSnackbar} 
          messageType="ISF"
          {...props} 
        />
      )}
      extraCngBreadcrumbNameMap={breadcrumbNameMap}
    />
  )
}

export {
  WrappedTablePage as TablePage
}
